// src/environments/environment.staging.ts
import { env } from './.env';
export const environment = {
  ...env,
  production: true,
  debug: false,
  version: env['npm_package_version'],

  serverUrl: 'https://stagesoGha3Phiiron1Aeq.fac3less.app/api',
  apiUrl: 'https://stagesoGha3Phiiron1Aeq.fac3less.app/api',
  chatUrl: 'https://s.chat.fac3less.app',
  conferenceDomain: 's.meet.fac3less.app',

  allowBalanceEdit: true,

  // Matomo Analytics Configuration
  matomo: {
    enabled: false, // Matomo switched off everywhere on 2026-10-10 (customer decision): replaced by the WolfPack Tracking Engine
    siteId: 2, // Credo staging site ID
    trackerUrl: 'https://a.fac3less.app/matomo.php',
    scriptUrl: 'https://a.fac3less.app/matomo.js',
    requireConsent: false,
    enableHeartBeatTimer: true,
    heartBeatTimerInterval: 15,
    enableLinkTracking: true,
    trackAppInitialLoad: true
  }
};